import { useUser } from '../../hooks/useUser'
import AdminToolsWidget from '../AdminToolsWidget'
import LangSelect from '../LangSelect'
import UserProfileWidget from '../UserProfileWidget'
import './index.scss'

const Header = () => {
  const { isAdmin } = useUser();

  return (
    <div className="Header">
      <UserProfileWidget />
      {isAdmin && <AdminToolsWidget />}
      <LangSelect />
    </div>
  )
}

export default Header
